/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DurationDto { 
    /**
     * Valore della durata
     */
    value: number;
    /**
     * Unità di misura: minuti, ore o giorni
     */
    unit: DurationDto.UnitEnum;
}
export namespace DurationDto {
    export const UnitEnum = {
        Seconds: 'seconds',
        Minutes: 'minutes',
        Hours: 'hours',
        Days: 'days',
        Weeks: 'weeks',
        Months: 'months',
        Years: 'years'
    } as const;
    export type UnitEnum = typeof UnitEnum[keyof typeof UnitEnum];
}


